<template>
  <div class="MouseParallax">
    <slot></slot>
  </div>
</template>

<script>
  import mouseParallax from '@/mixins/mouseParallax' 

  export default {
    name: "MouseParallax",
    props: [ 'mouseRatio' ],
    mixins: [ mouseParallax ],
    mounted()
    {
      if(this.mouseRatio)
        this.ratio = this.mouseRatio
    }
  }
</script>

<style lang="stylus" scoped>
.MouseParallax

  will-change transform
</style>